import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CampaignSearchInput } from './search-input-container';
import NewCampaign from '../../../../../app/engagement/components/NewCampaign';
import { InviteButtonContainer as InviteButton } from '../invite-button/invite-button.container';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import styles from './styles.module.scss';
import { getPermissions, isShopSessionView, useSession } from '../../../../infra/session';
import { useFeatureFlags } from '../../../../infra/feature-flags';
import { canUserViewBarbers, canUserModifyBarbers } from '../../../../../app/common/helpers/users';
export var EngageHeaderControls = function () {
    var _a, _b;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var session = useSession().data;
    var permissions = getPermissions(session);
    var isEngageForChairRentersFlagOn = useFeatureFlags().engageForChairRenters;
    var showInviteFeature = isShopSessionView(session === null || session === void 0 ? void 0 : session.view) &&
        ((_b = (_a = session === null || session === void 0 ? void 0 : session.view.viewer) === null || _a === void 0 ? void 0 : _a.barbers) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
        isEngageForChairRentersFlagOn &&
        canUserModifyBarbers(permissions) &&
        canUserViewBarbers(permissions);
    return (_jsxs("div", { className: "u-flex ".concat(styles['mobile-header-margin']), children: [!isMobileOrSmaller && isEngageForChairRentersFlagOn && _jsx(CampaignSearchInput, {}), _jsxs("div", { className: styles['buttons-container'], children: [showInviteFeature && _jsx(InviteButton, { variant: "button" }), _jsx(NewCampaign, {})] })] }));
};
